import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import ConvoNavBar from "../../../messages/components/convoNavBar";
import Convo from "../../../messages/components/convo";
import ConvoFooter from "../../../messages/components/convoFooter";

class LeadWaChatConvo extends Component {
    constructor(props) {
        super(props);
        this.lastMsgRef = React.createRef();
        this.state = {
            selectedUser: null,
            waMessageChats: [],
            hasMoreChats: false,
            loadingChats: false,
            chatPage: 1,
            isMobile: window.innerWidth <= 600,
        };
    }

    componentDidMount() {
        window.addEventListener("resize", this.handleResize);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleResize);
    }

    handleResize = () => {
        this.setState({ isMobile: window.innerWidth <= 600 });
    };

    scrollToLastMsg = () => {
        if (this.lastMsgRef?.current) {
            this.lastMsgRef.current.scrollIntoView();
        }
    };

    fetchPreviousChat = () => {
        const { loadingChats, hasMoreChats, selectedUser, chatPage } = this.state;
        if (!loadingChats && hasMoreChats && selectedUser !== null) {
            this.setState({ chatPage: chatPage + 1, loadingChats: true });
            setTimeout(() => {
                this.setState({ loadingChats: false });
            }, 500);
        }
    };

    render() {
        const { open, handleClose } = this.props;
        const { selectedUser, waMessageChats, loadingChats, chatPage, isMobile } = this.state;

        return (
            <Modal
                show={open}
                onHide={handleClose}
                size="lg"
                fullscreen={isMobile ? "md-down" : false}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>WhatsApp Chat</Modal.Title>
                </Modal.Header>

                <Modal.Body
                    style={{
                        padding: 0,
                        backgroundColor: "#fafafa",
                        display: "flex",
                        flexDirection: "column",
                        height: "600px",
                    }}
                >
                    {(!isMobile || (isMobile && selectedUser !== null)) && (
                        <div
                            style={{
                                display: "flex",
                                flexDirection: "column",
                                height: "700px",
                                border: "1px solid #ddd",
                                width: "100%",
                            }}
                        >
                            {/* Header */}
                            <div
                                style={{
                                    flexShrink: 0,
                                    borderBottom: "1px solid #ddd",
                                    backgroundColor: "#fff",
                                    zIndex: 10,
                                }}
                            >
                                {selectedUser !== null && <ConvoNavBar />}
                            </div>

                            {/* Chat Area */}
                            <div
                                style={{
                                    flex: 1,
                                    overflow: "auto",
                                    backgroundColor: selectedUser !== null ? "#f9f9f9" : "#f0f0f0",
                                    padding: "16px",
                                    display: "flex",
                                    flexDirection: "column-reverse",
                                    gap: "8px",
                                }}
                                id="scrollableChatDiv"
                            >
                                {selectedUser !== null ? (
                                    loadingChats && chatPage === 1 ? (
                                        <div style={{ textAlign: "center", padding: "32px" }}>
                                            <i className="fas fa-spinner fa-spin" style={{ fontSize: "24px", color: "#3b82f6" }} />
                                        </div>
                                    ) : (
                                        <Convo lastMsgRef={this.lastMsgRef} />
                                    )
                                ) : null}
                            </div>

                            {/* Footer */}
                            <div
                                style={{
                                    flexShrink: 0,
                                    borderTop: "1px solid #ddd",
                                    backgroundColor: "#fff",
                                    zIndex: 10,
                                }}
                            >
                                {selectedUser !== null && <ConvoFooter scrollToLastMsg={this.scrollToLastMsg} />}
                            </div>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        );
    }
}

export default LeadWaChatConvo;